"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _WorkflowConsumer = _interopRequireDefault(require("./WorkflowConsumer"));

var _excluded = ["id", "onClick", "disabled", "loading", "autoShowLoading", "onValidateTransition", "transitionName", "transitionTimeout", "disabledWhenNotValidated"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint react/prefer-stateless-function: 0 */

/* eslint no-useless-constructor: 0 */
var WorkflowNextButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WorkflowNextButton, _React$Component);

  var _super = _createSuper(WorkflowNextButton);

  function WorkflowNextButton() {
    var _this;

    (0, _classCallCheck2.default)(this, WorkflowNextButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      iAmTransitionInstigator: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isMounted", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "effectTransition", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref) {
        var currentStepId, nextStepId, goToStep, beginTransition, endTransition, transitionName, transitionTimeout, isTransitioning;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentStepId = _ref.currentStepId, nextStepId = _ref.nextStepId, goToStep = _ref.goToStep, beginTransition = _ref.beginTransition, endTransition = _ref.endTransition, transitionName = _ref.transitionName, transitionTimeout = _ref.transitionTimeout, isTransitioning = _ref.isTransitioning;
                beginTransition({
                  transitionName: transitionName,
                  transitionTimeout: transitionTimeout
                });

                _this.setState({
                  iAmTransitionInstigator: true
                }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                  var retVal, transitionWorkSucceeded;
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return _this.props.onValidateTransition(currentStepId, nextStepId);

                        case 3:
                          transitionWorkSucceeded = _context.sent;

                          if (transitionWorkSucceeded) {
                            goToStep({
                              stepId: nextStepId
                            });
                          }

                          if ((0, _isFunction2.default)(_this.props.onClick)) {
                            retVal = _this.props.onClick();
                          }

                        case 6:
                          _context.prev = 6;

                          if (_this._isMounted) {
                            _this.setState({
                              iAmTransitionInstigator: false
                            });
                          }

                          return _context.finish(6);

                        case 9:
                          endTransition();
                          return _context.abrupt("return", retVal);

                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0,, 6, 9]]);
                })));

                return _context2.abrupt("return", undefined);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(WorkflowNextButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          autoShowLoading = _this$props.autoShowLoading,
          onValidateTransition = _this$props.onValidateTransition,
          transitionName = _this$props.transitionName,
          transitionTimeout = _this$props.transitionTimeout,
          disabledWhenNotValidated = _this$props.disabledWhenNotValidated,
          restProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/(0, _jsx2.default)(_WorkflowConsumer.default, {}, void 0, function (_ref4) {
        var workflowDidMount = _ref4.workflowDidMount,
            currentStepId = _ref4.currentStepId,
            getNextStepId = _ref4.getNextStepId,
            goToStep = _ref4.goToStep,
            beginTransition = _ref4.beginTransition,
            endTransition = _ref4.endTransition,
            isTransitioning = _ref4.isTransitioning,
            getStepExtendedState = _ref4.getStepExtendedState;

        if (workflowDidMount) {
          var nextStepId = getNextStepId(currentStepId);
          var validationResults = getStepExtendedState(currentStepId, 'validationResults');
          var validated = validationResults && (0, _isEmpty2.default)(validationResults);
          return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
            id: id,
            onClick: /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(e) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        // eslint-disable-line arrow-parens
                        e.preventDefault();
                        _context3.next = 3;
                        return _this2.effectTransition({
                          currentStepId: currentStepId,
                          nextStepId: nextStepId,
                          goToStep: goToStep,
                          beginTransition: beginTransition,
                          endTransition: endTransition,
                          transitionName: transitionName,
                          transitionTimeout: transitionTimeout,
                          isTransitioning: isTransitioning
                        });

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x2) {
                return _ref5.apply(this, arguments);
              };
            }(),
            disabled: isTransitioning || disabled || !nextStepId || disabledWhenNotValidated && !validated,
            loading: loading || autoShowLoading && isTransitioning && _this2.state.iAmTransitionInstigator
          }, restProps), _this2.props.children);
        }

        return null;
      });
    }
  }]);
  return WorkflowNextButton;
}(_react.default.Component);

WorkflowNextButton.defaultProps = {
  onValidateTransition: function onValidateTransition(fromStepId, toStepId) {
    return true;
  },
  disabledWhenNotValidated: false
};
WorkflowNextButton.displayName = 'WorkflowV2.NextButton';
var _default = WorkflowNextButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowNextButton.js
// module id = 2143
// module chunks = 25